import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { useState, useRef } from 'react';
var COMMENT_SUGGESTION_TOOLTIP_DELAY = 1000; // wait 1sec before it displays
var COMMENT_SUGGESTION_TOOLTIP_DURATION = 8000; // show it for 8secs before hiding again
var useCommentOnDownloadSuggest = function () {
    var asGoodAsImmortal = useFlag('yumeruby');
    var _a = useState(false), commentTooltipVisible = _a[0], setCommentTooltipVisible = _a[1];
    var tooltipPaused = useRef(false);
    var visibilityTimeout;
    var showCommentSuggestionTooltip = function (delay) {
        if (delay === void 0) { delay = true; }
        visibilityTimeout = window.setTimeout(function () {
            setCommentTooltipVisible(true);
            visibilityTimeout = window.setTimeout(function () { return setCommentTooltipVisible(false); }, asGoodAsImmortal ? 1000000 : COMMENT_SUGGESTION_TOOLTIP_DURATION);
        }, delay ? COMMENT_SUGGESTION_TOOLTIP_DELAY : 0);
    };
    var hideCommentSuggestionTooltip = function () {
        setCommentTooltipVisible(false);
        clearTimeout(visibilityTimeout);
    };
    // When hovering over the Download button we want to avoid two tooltips showing at the same time,
    // so we hide this one and then show it again (if it was visible) when resume is called.
    var pauseCommentSuggestionTooltip = function () {
        if (commentTooltipVisible && !tooltipPaused.current) {
            hideCommentSuggestionTooltip();
            tooltipPaused.current = true;
        }
    };
    var resumeCommentSuggestionTooltip = function () {
        if (!commentTooltipVisible && tooltipPaused.current) {
            showCommentSuggestionTooltip(false);
            tooltipPaused.current = false;
        }
    };
    return {
        commentTooltipVisible: commentTooltipVisible,
        showCommentSuggestionTooltip: showCommentSuggestionTooltip,
        hideCommentSuggestionTooltip: hideCommentSuggestionTooltip,
        pauseCommentSuggestionTooltip: pauseCommentSuggestionTooltip,
        resumeCommentSuggestionTooltip: resumeCommentSuggestionTooltip,
    };
};
export default useCommentOnDownloadSuggest;
//# sourceMappingURL=useCommentOnDownloadSuggest.js.map